"use client";

import { useState } from "react";

export function Poster({ src, title }: { src: string | null; title: string }) {
  const [failed, setFailed] = useState(false);
  return src && /^https?:\/\//i.test(src) && !failed
    ? <img src={src} alt={title} loading="lazy" decoding="async" onError={() => setFailed(true)} />
    : <div className="poster-fallback"><span aria-hidden="true">d.</span><small>Poster belum tersedia</small></div>;
}

